module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Black-WebXL-8fa2f31255182526a92b9224c4ac57f9.woff2";